// Map FastAPI 422 detail arrays / string details / random objects
// down to a single human-readable string.
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return (
      detail
        .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
        .filter(Boolean)
        .join(" ") || "Validation error."
    );
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function extractError(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Unknown error";
}
